<template>
  <div class="container-fluid mt-6 px-5">
    <div class="row mt-3" id="lower-div">
      <div class="card mb-4">
        <div v-loading="loading">
          <div class="p-2" m="4">
            <div class="card-body px-0 pt-0 pb-3">
              <titles text="Xəbərdarlıqlar jurnalı" />
              <hr class="my-3" />
              <div class="mb-3 d-flex align-items-center gap-2">
                <el-input v-model="searchText" size="large" placeholder="Axtarış" style="width:220px"
                  @keyup.enter="loadWarnings(1)" />
                <soft-button @click="loadWarnings(1)">
                  <i class="fas fa-search"></i>&nbsp;Axtar
                </soft-button>
                <soft-button type="button" class="btn-excel" @click="exportToExcel">
                  <i class="fas fa-file-excel"></i>
                </soft-button>
              </div>
              <warnings-journal-table :data="warnings" />
              <div class="d-flex justify-content-start mt-3">
                <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                  :current-page="page" @current-change="loadWarnings" />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Titles from "@/project/Components/Titles.vue"
import SoftButton from "@/components/SoftButton.vue"
import WarningsJournalTable from "@/project/Components/Tables/WarningsJournalTable.vue"
import { GetWarningJournal } from "@/project/Source/journals"
import * as XLSX from "xlsx"              

export default {
  components: { Titles, SoftButton, WarningsJournalTable },
  data() {
    return {
      warnings: [],
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      searchText: ""
    }
  },
  mounted() { this.loadWarnings() },
  methods: {
    async loadWarnings(page = this.page) {
      this.loading = true
      try {
        const { data } = await GetWarningJournal({
          page,
          pageSize: this.pageSize,
          searchText: this.searchText.trim()
        })

        this.warnings = data.data

        this.total = data.data.length ? data.data[0].totalCount : 0
        this.page = page
      } finally { this.loading = false }
    },

    exportToExcel() {
      if (!this.warnings.length) return
      const data = this.warnings.map(w => ({
        "Subroqasiya №": w.subrogationNumber,
        "Təsvir": w.description || "-",
        "Status": w.statusName,
        "Gecikmə günü": w.overdueDays
      }))
      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, "Xəbərdarlıqlar")
      XLSX.writeFile(wb, "xeberdarliq_jurnali.xlsx")
    }
  }
}
</script>
